import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ParkMachineSerializer from '../../../services/park-machine/ParkMachineSerializer';
import * as parkMachineCategoryActions from "../../../actions/park-machine/parkMachineCategoryActions";
import * as parkMachineActions from "../../../actions/park-machine/parkMachineActions";
import * as modalActions from '../../../actions/common/modalActions';
import * as submitButtonActions from '../../../actions/submit/submitButtonActions';
import {toastr} from 'react-redux-toastr';
import {injectIntl} from 'react-intl';
import {messages} from  '../../common/Translations';
import WithResolvedPromises from "../../common/WithResolvedPromises";
import Placeholder from "../../Placeholder";
import PlaceholderError from "../../common/PlaceholderError";
import ResetFormModal from "../../ResetFormModal";
import ParkMachineForm from "./ParkMachineForm";
import {getFormSyncErrors, getFormValues} from "redux-form";
import PrivateAPIResource from "../../../services/PrivateAPIResource";

class ParkMachineContainer extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.onParkMachinePhotoChange = this.onParkMachinePhotoChange.bind(this);
        this.submit = this.submit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.isUpdate = this.isUpdate.bind(this);
        this.actions = this.getRequiredActions();
        this.defaultImageProps = {
            mimeType: "image/x-png, image/png, image/jpg, image/jpeg",
            maxWeight: 10, // Mb
        };
        this.state = {
            parkMachinePhoto: null
        };
    }

    getRequiredActions() {
        let actions = [
            this.props.actions.getParkMachineCategories()
        ];
        if (this.isUpdate()) {
            actions.push(this.props.actions.getParkMachine(this.props.match.params.id))
        } else {
            actions.push(this.props.actions.resetParkMachine());
        }
        return actions;
    }

    onParkMachinePhotoChange(e) {
        this.setState({parkMachinePhoto: e.target.files[0]});
    }

    submit(formFields) {

        this.props.actions.showSubmitButtonSpinner();
        let fields = ParkMachineSerializer.serialize({...formFields});

        let formData = new FormData();
        formData.append('brand', fields.brand);
        formData.append('categoryId', fields.categoryId);
        formData.append('model', fields.model);
        formData.append('quantity', fields.quantity);
        formData.append('removeImage', (fields.removeImage ? 1 : 0));
        formData.append('statusCode', fields.statusCode);

        if (this.state.parkMachinePhoto) {
            let imageFile = this.state.parkMachinePhoto;

            if (!this.defaultImageProps.mimeType.includes(imageFile.type)) {
                toastr.error(`Billedet skal være ${this.defaultImageProps.mimeType}`);
                this.props.actions.hideSubmitButtonSpinner();
                return;
            }

            if (imageFile.size) {
                let sizeMb = imageFile.size / 1024 / 1024;
                if (sizeMb > this.defaultImageProps.maxWeight) {
                    toastr.error(`Billedstørrelse skal være mindre eller lig med ${this.defaultImageProps.maxWeight}mb`);
                    this.props.actions.hideSubmitButtonSpinner();
                    return;
                }
            }

            formData.append('image', this.state.parkMachinePhoto);
        }

        if (this.isUpdate()) {
            PrivateAPIResource
                .update('park-machine/update', this.props.match.params.id, formData, true)
                .then(() => {
                    toastr.success('Maskinpark blev opdateret');
                    this.redirect();
                })
                .catch((e) => {
                    toastr.error(e.toString());
                })
                .finally(() => {
                    this.props.actions.hideSubmitButtonSpinner()
                });
        } else {
            PrivateAPIResource
                .create('park-machine/create', formData, true)
                .then(() => {
                    toastr.success('Maskinpark oprettet');
                    this.redirect();
                })
                .catch((e) => {
                    toastr.error(e.toString());
                })
                .finally(() => {
                    this.props.actions.hideSubmitButtonSpinner()
                });
        }
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    redirect() {
        this.context.router.history.push('/park');
    }

    render() {

        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">{this.isUpdate() ? 'Opdatér maskinpark' : 'Opret maskinpark'}</h1>
                                <ParkMachineForm
                                    initialValues={this.props.parkMachine}
                                    onSubmit={this.submit}
                                    handleReset={this.handleReset}
                                    isUpdate={this.isUpdate}
                                    parkMachineCategories={this.props.parkMachineCategories}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                    onParkMachinePhotoChange={this.onParkMachinePhotoChange}
                                />
                            </div>
                        </div>
                    </div>
                    <ResetFormModal
                        modalTitle={"Nulstil ændringer"}
                        modalContent={<p> Er du sikker på at du vil annullere? Alle dine ændringer vil gå tabt </p>}
                        confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                        closeText={this.props.intl.formatMessage(messages.buttonNo)}
                        handleConfirm={() => {this.confirmReset()}}
                    />
                </div>
            </WithResolvedPromises>
        );
    }
}

ParkMachineContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let errors      = Object.assign({}, getFormSyncErrors('parkMachine')(state));
    let formValues  = Object.assign({}, getFormValues('parkMachine')(state));

    return {
        parkMachine: state.parkMachine,
        parkMachineCategories: state.parkMachineCategories,
        errors,
        formValues,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...parkMachineActions,
            ...parkMachineCategoryActions,
            ...submitButtonActions,
            ...modalActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ParkMachineContainer));





// WEBPACK FOOTER //
// ./web/src/components/park-machine/park-machine/ParkMachineContainer.jsx